import React from 'react';
import './embeds.css';

/**
 * DataTable
 * Supports two input shapes:
 * 1) columns: [{ key, label, formatter? }], rows: [{ key: value, ... }]
 * 2) columns: [string, ...], rows: [[value, ...]] (array-of-arrays)
 */
export default function DataTable({ columns = [], rows = [], rowClick }) {
  // Normalize columns to objects with key/label
  const normColumns = (columns || []).map((col, idx) =>
    typeof col === 'string'
      ? { key: `col_${idx}`, label: col }
      : col
  );

  if (!normColumns.length) return null;

  // Normalize rows: if array -> map to object keyed by column order
  const normRows = (rows || []).map((row) => {
    if (Array.isArray(row)) {
      const obj = {};
      normColumns.forEach((col, idx) => {
        obj[col.key] = row[idx];
      });
      return obj;
    }
    return row;
  });

  return (
    <div className="embed-table-wrap">
      <table className="embed-table">
        <thead>
          <tr>
            {normColumns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {normRows.map((row, idx) => (
            <tr
              key={idx}
              onClick={rowClick ? () => rowClick(row) : undefined}
              className={rowClick ? 'clickable' : undefined}
            >
              {normColumns.map((col) => {
                const raw = row[col.key];
                const val = col.formatter ? col.formatter(raw, row) : raw;
                return <td key={col.key}>{val}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
